import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import { useUserStore } from "@/components/login/loginStore";
import { Button, Link, Modal, ModalContent, ModalHeader, ModalBody, useDisclosure } from "@heroui/react";
import { useTranslation } from 'react-i18next';

export default function RobotipPromo({ hideMenu }: { hideMenu: boolean }) {
    const { t } = useTranslation();
    const [dismissed, setDismissed] = useState(false);
    const [availableToUser, setAvailableToUser] = useState(false);
    const [canRender, setCanRender] = useState(false);
    const [hideBanner, setHideBanner] = useState(false);

    const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure();

    const loginStore = useUserStore((state) => state);


    useEffect(() => {
        if (localStorage.getItem("robotipPromoDismissed") === "true") {
            setDismissed(true);
        }
    }, []);

    useEffect(() => {
        let daysSincePayment;
        if (loginStore.payment_date) {
            const paymentDate = loginStore.payment_date;
            const today = new Date();
            const diffTime = Math.floor(today.getTime() / 1000) - paymentDate;
            daysSincePayment = Math.floor(diffTime / (60 * 60 * 24));
        }
        if (daysSincePayment && daysSincePayment > 7) {
            setAvailableToUser(true);
        }
    }, [loginStore]);

    useEffect(() => {
        if (availableToUser && !dismissed && !hideMenu) {
            setCanRender(true);
        } else {
            setCanRender(false);
        }
    }, [availableToUser, dismissed, hideMenu]);

    const dismiss = () => {
        localStorage.setItem("robotipPromoDismissed", "true");
        setDismissed(true);
    };

    const openModal = () => {
        onOpen();
        setHideBanner(true);
    };

    return canRender && (
        <div>
            <Modal isOpen={isOpen} onOpenChange={onOpenChange} onClose={() => { onClose(); dismiss() }} className="my-auto">
                <ModalContent>
                    <ModalHeader className="flex flex-col gap-1">{t('robotip_promo.robotip_promo_1')}</ModalHeader>
                    <ModalBody>
                        <Link href="http://landing.robotip.com.br/?a=avbets&utm_campaign=avbets" target="_blank" className="mx-auto mb-4">
                            <img src="/static/imgs/banner-robotip.png" alt="RobôTip Promo" className="mx-auto" />
                        </Link>
                        <Button
                            as={Link}
                            href="https://robotip.com.br/planos?coupon=E0A33&a=avbets&utm_campaign=avbets"
                            target="_blank"
                            className="mx-auto mb-4"
                            startContent={
                                <Icon
                                    className="flex-none outline-none transition-transform group-data-[hover=true]:translate-x-0.5 [&>path]:stroke-[2]"
                                    icon="ri:external-link-line"
                                    width={16}
                                />
                            }
                            color="success"
                        >
                            {t('robotip_promo.robotip_promo_2')}
                        </Button>
                    </ModalBody>
                </ModalContent>
            </Modal>

            <div className="pointer-events-auto flex w-full items-center justify-between gap-x-20 rounded-large border border-divider bg-background/15 px-6 py-4 shadow-small backdrop-blur"
                style={{ display: hideBanner ? "none" : "flex" }}
            >
                <div className="text-small text-foreground hover:text-default-500 cursor-pointer flex flex-col md:flex-row gap-4 md:items-center" onClick={openModal}>
                    <span className="">
                        {t('robotip_promo.robotip_promo_3')}
                    </span>
                    <Button
                        className="group relative h-9 overflow-hidden bg-transparent text-small font-normal"
                        color="default"
                        endContent={
                            <Icon
                                className="flex-none outline-none transition-transform group-data-[hover=true]:translate-x-0.5 [&>path]:stroke-[2]"
                                icon="solar:arrow-right-linear"
                                width={16}
                            />
                        }
                        href="#"
                        style={{
                            border: "solid 2px transparent",
                            backgroundImage: `linear-gradient(hsl(var(--heroui-background)), hsl(var(--heroui-background))), linear-gradient(83.87deg, hsl(var(--heroui-primary-800)), hsl(var(--heroui-primary-600)))`,
                            backgroundOrigin: "border-box",
                            backgroundClip: "padding-box, border-box",
                        }}
                        variant="bordered"
                        onClick={openModal}
                    >
                        {t('robotip_promo.robotip_promo_4')}
                    </Button>
                </div>
                <div className="flex flex-1 justify-end">
                    <Button isIconOnly className="-m-1" size="sm" variant="light" onClick={dismiss}>
                        <span className="sr-only">{t('robotip_promo.robotip_promo_5')}</span>
                        <Icon className="text-default-500" icon="lucide:x" width={20} />
                    </Button>
                </div>
            </div>
        </div>
    );
}
